import React, { useState, useEffect } from 'react';
import { Tabla } from './Tabla';
import BannersEditar from '../types/BannersEditar';
import ObtenerBanners from '../functions/ObtenerBanners';
import ObtenerBannersSinContenido from '../functions/ObtenerBannersSinContenido';

interface ListarBannersProps {
    defaultItemsPerPage?: number;
    handleEdit: (banner: BannersEditar) => void;
    handleDelete: (banner: BannersEditar) => void;
    handleAdd: () => void
}

export const ListarBanners: React.FC<ListarBannersProps> = ({ defaultItemsPerPage = 15, handleEdit, handleDelete, handleAdd, }) => {
  
  const [banners, setBanners] = useState<BannersEditar[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [itemsPerPage, setItemsPerPage] = useState(defaultItemsPerPage);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const data = await ObtenerBannersSinContenido();
        setBanners(data.banners);
        setLoading(false);
      } catch (err) {
        setError('Error al obtener los Banners:' + err);
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  const columns = [
    { key: 'id', label: 'ID', align: 'center' as const },
    { key: 'titulo', label: 'TÍTULO', align: 'left' as const },
    { key: 'enlace', label: 'ENLACE', align: 'left' as const },
    { key: 'habilitado', label: 'HABILITADO', align: 'center' as const },
    { key: 'mostrar_web', label: 'MOSTRAR EN WEB', align: 'center' as const },
    { key: 'dado_baja', label: 'DADO DE BAJA', align: 'center' as const },
  ];

  const handleEditLocal = (banner: BannersEditar) => {
    handleEdit(banner);
  };

  const handleDeleteLocal = (banner: BannersEditar) => {
    handleDelete(banner);
  };

  const handleCredencialLocal = (banner: BannersEditar) => {
    console.log('Mostrar credencial', banner);
  }

  const handleUbicationLocal = (banner: BannersEditar) => {
    console.log('Mostrar ubicacion', banner);
  };

  if (loading) return <div>Cargando...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-5">
      <div className="flex flex-row justify-between items-center mb-3">
        <div className="flex flex-col justify-center items-center">
          <h1 className="font-metropolis text-xl font-bold">Banners cargados</h1>
        </div>
        <div className="flex flex-col justify-center items-center">
          <button className="vp-btn-azul-sm" onClick={handleAdd}>Nuevo Banner</button>
        </div>
      </div>
      <Tabla columns={columns} data={banners} onEdit={handleEditLocal} onDelete={handleDeleteLocal} itemsPerPage={itemsPerPage} onCredencial={handleCredencialLocal} onUbication={handleUbicationLocal} acciones={['editar','eliminar']}/>
    </div>
  );
};